export const OFFER_STATE_LABEL = {
  draft: 'Draft event',
  sent: 'Sent',
  accepted: 'Accepted',
  declined: 'Declined',
};

export function statePillFor(offer, confirm) {
  if (offer.calendar_event_id && offer.state !== 'declined') {
    const type = confirm?.type || (confirm ? 'Confirm' : null);
    if (type === 'Hold') return { label: 'Hold', modifier: 'hold' };
    if (type === 'Confirm') return { label: 'Confirm', modifier: 'confirm' };
  }
  const label = OFFER_STATE_LABEL[offer.state] || offer.state;
  return { label, modifier: 'default' };
}

// Short-form date chip without the year — always returns `EEE, MMM d`.
export function formatHeaderDate(startTime) {
  if (!startTime) return null;
  const d = new Date(startTime);
  if (isNaN(d.getTime())) return null;
  return d.toLocaleDateString('en-US', {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
  });
}

export function initials(name) {
  if (!name) return '?';
  return name
    .split(/\s+/)
    .slice(0, 2)
    .map((s) => s[0] || '')
    .join('')
    .toUpperCase();
}
